import { reconstructUrl } from './reconstruct-url';

// Expected format of the static HTML file path: `/_static/index_<hash>.html`
const STATIC_HTML_RE = /^\/_static\/index_([a-f0-9]+)\.html$/i;

/** Minimal `window` surface used by the frontend-router bootstrap (tests can mock this). */
export type FrontendRouterWindow = {
  location: Pick<Location, 'pathname' | 'hash' | 'origin' | 'search'>;
  history: Pick<History, 'replaceState'>;
};

/**
 * When the app is served from `/_static/index_<hash>.html` (frontend-router),
 * sets `__INFIELD_BUILD_VERSION__` and rewrites the URL via `history.replaceState`.
 *
 * Adapted from `apps/fusion-shell/src/frontend-router/frontend-router-setup.ts`.
 */
export function applyInfieldFrontendRouterSetup(
  win: FrontendRouterWindow
): void {
  const path = win.location.pathname;

  if (!path.startsWith('/_static/')) {
    return;
  }

  try {
    const match = STATIC_HTML_RE.exec(path);
    if (match) {
      const version = match[1];
      Object.defineProperty(win, '__INFIELD_BUILD_VERSION__', {
        value: version,
        writable: false,
        configurable: false,
        enumerable: true,
      });
    }
  } catch (error) {
    console.error('Failed to extract the version from the URL', error);
  }

  try {
    const url = reconstructUrl(win.location);
    win.history.replaceState(null, '', url);
  } catch (error) {
    console.error(
      'Failed to reconstruct the URL after frontend-router redirect',
      error
    );
  }
}
